import { CampaniasService } from '../../core/_infrastructure/classes/services/campanias-global.service';
import { GlobalService } from '../../core/_infrastructure/classes/services/global.service';
import { Tc } from '../../core/_infrastructure/types/common';
import { TwSolicitudCamViewModelBase } from './solicitudcam-datosbasicos.types';

export class CampaniaBase {
    public provincias: Tc[] = [];
    public municipios: Tc[] = [];
    protected filtroBase: TwSolicitudCamViewModelBase | null;

    constructor(
        protected globalService: GlobalService,
        protected campaniasService: CampaniasService,
    ) {
        this.filtroBase = new TwSolicitudCamViewModelBase();
    }

    /**
     * @author: scalero1
     * FUNCIONALIDAD IDÉNTICA EN EL COMPONENTE codigoconfeccion-wrapper
     * La lista de provincias del desplegable se cargará en función de si el ámbito del periodo es nacional o no.
     * - Si es nacional, se cargarán todas las provincias de la CA (del periodo de la solicitud)
     * - Si no es nacional:
     *      - habrá un configuración a nivel provincial (TPeriodoAmbitoProvinciaCam)
     *      - Si no hay configuración a nivel provincial:
     *              - Se cargarán todas las provincias de la configuración de la CA (TPeriodoAmbitoCaCam)
     */
    protected loadProvincias(): void {
        this.provincias = [];
        if (this.filtroBase) {
            if (this.filtroBase.AmbitoNacional) {
                this.getProvinciasByCa(this.filtroBase.IdCa);
            } else {
                this.getProvinciasByPeriodoAmbitoProvincia(this.filtroBase.IdPeriodoCam, this.filtroBase.IdCa);
            }
        } else {
            this.getAllProvincias();
        }
    }

    /**
     * Provincias configuradas en AmbitoProvincia.
     * Si no hay, se comprueba la configurada para el ambito de la CA.
     * @param idPeriodoCam number
     * @param idCa number
     */
    private getProvinciasByPeriodoAmbitoProvincia(idPeriodoCam: number, idCa: number): void {
        if (!idPeriodoCam || !idCa) {
            return;
        }
        this.campaniasService.getProvinciasByPeriodoAmbitoProvincia(idPeriodoCam).subscribe(res => {
            if (!res || res.length === 0) {
                this.getProvinciasByPeriodoAmbitoCa(idPeriodoCam, idCa);
                return;
            }
            this.provincias = res;
        });
    }

    /**
     * Provincias configuradas para la CA
     * @param idCa number
     */
    private getProvinciasByCa(idCa: number): void {
        if (!idCa) {
            return;
        }
        this.globalService.getProvinciasByComunidad(idCa).subscribe((provincias: Tc[]) => {
            this.provincias = provincias;
        });
    }

    /**
     * Provincias a partir del ámbito configurado para la CA.
     * Si no hay, se obtienen todas las provincias de la CA.
     * @param idPeriodoCam number
     * @param idCa number
     */
    private getProvinciasByPeriodoAmbitoCa(idPeriodoCam: number, idCa: number): void {
        if (!idPeriodoCam || !idCa) {
            return;
        }
        this.campaniasService.getProvinciasByPeriodoAmbitoCa(idPeriodoCam, idCa).subscribe(res => {
            if (!res || res.length === 0) {
                this.getProvinciasByCa(idCa);
                return;
            }
            this.provincias = res;
        });
    }

    /**
     * Se obtienen todas las provincias.
     */
    private getAllProvincias(): void {
        this.globalService.getProvincias().subscribe((provincias: Tc[]) => {
            this.provincias = provincias;
        });
    }

    /**
     * Invoked when the user selects a "Provincia" in the filter
     * @param provinciaId number
     * @return void
     */
    public onProvinciaSelected(provinciaId: number): void {
        this.municipios = [];
        if (!provinciaId) {
            return;
        }
        this.globalService.getMunicipios(provinciaId).subscribe((municipios: Tc[]) => {
            this.municipios = municipios;
        });
    }
}
